<template>
  <v-col
    cols="3"
  >
    <v-card>
      <v-card-title>
        Giveaways
      </v-card-title>
      <v-card-text>
        Thanks for participating!
      </v-card-text>
      <!-- For this first hackathon, we will assume there's only one giveaway type -->
      <v-card-actions>
        <v-dialog
          v-model="giveawaysDialog"
          width="500"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="access-perks-button"
              v-bind="attrs"
              :title="giveawaysCtaText"
              v-on="on"
            >
              {{ giveawaysCtaText }}
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              Giveaway Details
            </v-card-title>
            <giveaways-redeem
              :current-user="currentUser"
              @closeDialog="() => { giveawaysDialog = false }"
            />
          </v-card>
        </v-dialog>
      </v-card-actions>
    </v-card>
  </v-col>
</template>

<script>
import GiveawaysRedeem from '@/components/GiveawaysRedeem.vue';
import GiveawaysClient from '@/api/GiveawaysClient';
import { mapGetters } from 'vuex';

export default {
  name: 'Giveaways',
  components: {
    GiveawaysRedeem,
  },
  props: {
    currentUser: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      giveawaysDialog: false,
      haveARedeemedPerk: false,
    };
  },
  computed: {
    ...mapGetters({
      currentJwtToken: 'currentJwtToken',
    }),
    giveawaysCtaText() {
      return !this.haveARedeemedPerk ? 'Redeem your perks' : 'Access your perks';
    },
  },
  mounted() {
    this.getGiveawaysData();
  },
  methods: {
    async getGiveawaysData() {
      const eventId = this.$store.state.hackathonID || '';
      if (eventId !== '') {
        /* eslint-disable-next-line max-len */
        const giveawaysClient = new GiveawaysClient(this.currentJwtToken, eventId);
        const responseData = await giveawaysClient.getGiveaways();
        this.availableGiveawayTypes = responseData.map((giveawayType) => giveawayType.type);
        if (responseData !== undefined) {
          responseData.forEach((giveawayType) => {
            if (giveawayType.redeemed) {
              this.haveARedeemedPerk = true;
            }
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .v-card__title {
    padding-bottom: 0;
  }

  .access-perks-button {
    background-color: #004e7d!important;
    color: #fff!important;

    ::v-deep .v-btn__content {
      text-transform: uppercase;
    }
  }

  .v-card__actions {
    padding: 0 1rem 1rem 1rem;
  }
</style>
